<template>
    <div style="position:relative" id="status_and_workflow">
        <div class="workflow_action">
            <h3>New student data entry instructions</h3>
            <p>If this record should be a student record, you may change record type by changing the status to 'Prospective' student</p>

            <el-button type="primary" size="small" @click="onSubmit('prospective')">Change status to 'Prospective'</el-button>

            <p>If this student has arrived with documentation in hand, you may</p>

            <el-button type="primary" size="small" @click="onSubmit('applicant')">Change status to 'Applicant'</el-button>

            <p>If this student is a guest of the University who needs accommodations, you may</p>

            <el-button type="primary" size="small" @click="onSubmit('guest_pending_assignment')">Change status to 'Guest'</el-button>

            <p>If this student is only applying for housing accommodations, you may</p>

            <el-button type="primary" size="small" @click="onSubmit('ha_only')">Change status to 'HA Only'</el-button>

            <p>If this record should be a faculty record, you must delete this record and create a faculty record in the faculty module.</p>
            <student-student-workflow-system-administrator-options :id="id" :studentName="studentName" v-on:refreshstudent="refreshStudent"></student-student-workflow-system-administrator-options>
        </div>
   </div>
</template>
<script>
    import axios from 'axios'



    export default {
        components: {

        },
        data() {
            return {
            }
        },
        props: ['id', 'studentName'],
        methods: {
            onSubmit(newStatus) {
                this.$message.closeAll();
                
                axios.put("/api/student/change-status/", {
                        id: parseInt(this.id),
                        new_status: newStatus
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.$emit('refreshstudent');
                        } else {
                            this.$message({
                                showClose: true,
                                duration: 20000,
                                type: 'error',
                                message: response.data.message
                            });
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            },
            refreshStudent: function(){
                this.$emit('refreshstudent');
            }
        }
    }
</script>
<style scoped>
</style>